module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b89d281","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BannerBlock/BannerBlock.vue
// module id = 3621
// module chunks = 1